import OfferSections from './OfferSections';

export default OfferSections;
